export default __webpack_public_path__ + "static/media/python.39775061.svg";